export { CashBackDetails, CashBackTermsLink, bankStatementTerms } from './cash-back-details';
